import React, { useEffect, useState } from 'react';
import styles from '../../assets/styles/Admin.module.scss';
import { formatDate } from '../../utils/date';
import { INQUIRY_STATUS_MAP } from '../../utils/constants';

interface Inquiry {
  id: string;
  raw_id: number;
  userName: string;
  company: string;
  email: string;
  phone: string;
  title: string;
  status: string;
  date: string;
}

import { useNavigate } from 'react-router-dom';

const AdminInquiries: React.FC = () => {
  const navigate = useNavigate();
  const [inquiries, setInquiries] = useState<Inquiry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInquiries = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/admin/inquiries/list`, {
          credentials: 'include',
        });
        if (res.ok) {
          const data = await res.json();
          setInquiries(data.data || []);
        }
      } catch (error) {
        console.error('お問い合わせ取得エラー', error);
      } finally {
        setLoading(false);
      }
    };
    fetchInquiries();
  }, []);

  return (
    <div className={styles.contentBox}>
      <div className={styles.pageHeader}>
        <h1>お問い合わせ</h1>
        <p>ユーザーからのフィードバックやサポート依頼</p>
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.adminTable}>
          <thead>
            <tr>
              <th>ID</th>
              <th>ユーザー名</th>
              <th>企業名</th>
              <th>メールアドレス</th>
              <th>電話番号</th>
              <th>お問い合わせ内容</th>
              <th>ステータス</th>
              <th>日付</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={8} className={styles.tableCenterCell}>
                  読み込み中...
                </td>
              </tr>
            ) : inquiries.length === 0 ? (
              <tr>
                <td colSpan={8} className={styles.tableCenterCell}>
                  現在、お問い合わせはありません。
                </td>
              </tr>
            ) : (
              inquiries.map((inquiry) => (
                <tr key={inquiry.id} onClick={() => navigate(`/admin/inquiries/${inquiry.raw_id}`)}>
                  <td>#{inquiry.id}</td>
                  <td>{inquiry.userName}</td>
                  <td>{inquiry.company}</td>
                  <td>{inquiry.email}</td>
                  <td>{inquiry.phone}</td>
                  <td>{inquiry.title}</td>
                  <td>
                    <span className={`${styles.badge} ${styles[inquiry.status]}`}>
                      {INQUIRY_STATUS_MAP[inquiry.status] || inquiry.status}
                    </span>
                  </td>
                  <td>{formatDate(inquiry.date)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminInquiries;
